import { sortBy } from 'lodash';

type RhinoRecord = Record<string, unknown>;

export const sorters: Record<string, (player: RhinoRecord) => unknown> = {
  last_name: (player) => player.last_name,
  number: (player) => parseInt(player.number as string),
  position: (player) => (player?.position as RhinoRecord)?.abbreviation
};

export const freshPlayerArray = () =>
  Array.from({ length: 5 }, (_, i) => ({
    id: -i - 1,
    number: '',
    last_name: '',
    position: -1,
    hand: null as string | null,
    rating: null as string | null,
    commitment: '',
    convert: false
  }));

// The rows a team's roster loads into. A real roster is sorted by number; an
// empty one falls back to blank starter rows, the same as a team that has never
// been scouted — a team season can exist with no players yet (a placeholder one
// an import created ahead of its roster), and without this the scout lands on an
// empty, uneditable list with no way to add anyone.
export const rosterForForm = (results: unknown[] | undefined) =>
  results && results.length > 0
    ? sortBy(results, [sorters.number])
    : freshPlayerArray();
